document.addEventListener('DOMContentLoaded', () => {
    let iTix = document.createElement('iframe');
    iTix.setAttribute('id', 'tix');
    iTix.style.display = 'none';

    iTix.setAttribute('src', 'https://tix.theaterdevest.nl/nl/itix');

    document.body.appendChild(iTix);

    iTix.onload = function () {
        iTix.contentWindow.postMessage('GetSession', 'https://tix.theaterdevest.nl');
    };
});

window.addEventListener('message', (e) => {
    if (!e.isTrusted)
        return;
    const basket = document.getElementById('basket');
    const basketCount = basket.querySelector('.basket-count');
    const loginLinks = document.querySelectorAll('.login');

    if (e) {
        let data = e.data;

        if (data.order) {
            basket.classList.add('is-active');
            basketCount.innerHTML = data.order.items.length;
        } else {
            basket.classList.remove('is-active');
        }

        if (data.user) {
            loginLinks.forEach((login) => {
                login.setAttribute('title', data.user.email);
                let profileUrl = data.profile ? data.profile : login.dataset.profileurl;
                login.setAttribute('href', profileUrl);
                let letterSpan = login.querySelector('.login-letter');
                let letter = data.user.name ? data.user.name.charAt(0).toUpperCase() : data.user.email.charAt(0).toUpperCase();
                letterSpan.innerHTML(letter);
                login.classList.add('is-active');
            });
        } else {
            loginLinks.forEach((login) => {
                login.removeAttribute('title');
                let loginUrl = data.login ? data.login : login.dataset.loginurl;
                login.setAttribute('href', loginUrl);
                login.classList.remove('is-active');
            });
        }
    }
}, false);